<app-top-nav></app-top-nav>

<div class="content">
  <div class="wrapper">
    <p class="title" i18n="@@admin.initial.load">Initial load</p>
    <div class="d-flex flex-row mb-2"></div>
    <form [formGroup]="initialLoadUploadForm" class="initial-load-form">
      <div class="form-item fileToUpload">
        <label class="form-label required">File to upload</label>
        <div class="input-wrapper clickable">
          <input
            type="file"
            formControlName="fileToUpload"
            accept="text/xml"
            (change)="selectFile($event)"
          />
          <span
            *ngIf="
              (initialLoadUploadForm.get('fileToUpload').touched ||
                initialLoadUploadForm.get('fileToUpload').dirty) &&
              initialLoadUploadForm.get('fileToUpload').errors
            "
            class="invalid-feedback"
          >
            <span
              *ngIf="initialLoadUploadForm.get('fileToUpload').errors.required"
              >Please select a file to upload.</span
            >
          </span>
        </div>
      </div>

      <div>
        <span *ngIf="uploadErrors" class="invalid-feedback">
          {{ uploadErrors }}
        </span>
      </div>
    </form>
    <div d-flex flex-row class="mt-5"></div>
    <button
      class="trigger text-uppercase mr-2"
      [disabled]="!fileToUpload"
      [ngClass]="{
        'button-inactive': !fileToUpload
      }"
      (click)="sendInitialLoadTrigger()"
      i18n="@@admin.initial.load.trigger"
    >
      Trigger initial load
    </button>
  </div>
</div>
